import { RouteWaypoint } from "@iventis/domain-model/model/routeWaypoint";
import { ModeOfTransport } from "@iventis/domain-model/model/modeOfTransport";
import { EventStreamWithStoredValue } from "@iventis/utilities";
import { TimeSpan } from "@iventis/types";

export enum RoutePlannerEvent {
    /** Clears any local data inside the route planner and sets it the the payload in this event */
    SetRouteWaypoints = "SetRouteWaypoints",
    /** Sets the route information such as distance and time */
    SetRouteInfo = "SetRouteInfo",
    /** Sets the mode of transport */
    SetModeOfTransport = "SetModeOfTransport",
    /** Tells the route planner we've begun loading the waypoints */
    LoadingWaypoints = "LoadingWaypoints",
}

export type RouteData = {
    waypoints: RouteWaypoint[];
    routeInfo: RouteInfo;
    modeOfTransport: ModeOfTransport;
};

export type SetRouteWaypointsEvent = {
    type: RoutePlannerEvent.SetRouteWaypoints;
    payload: Pick<RouteData, "waypoints">;
};

export type RouteInfo = {
    /** Distance in meters */
    distance: number;
    /** Duration as a TimeSpan */
    duration: TimeSpan;
};

export type SetRouteInfoEvent = {
    type: RoutePlannerEvent.SetRouteInfo;
    payload: Pick<RouteData, "routeInfo">;
};

export type SetSetModeOfTransportEvent = {
    type: RoutePlannerEvent.SetModeOfTransport;
    payload: Pick<RouteData, "modeOfTransport">;
};

export type SwitchRouteEvent = {
    type: RoutePlannerEvent.LoadingWaypoints;
    payload: null;
};

/** An event stream required for keeping the data table in sync with the map (MAP --> ROUTE PLANNER) */
export const routePlannerEventStream = new EventStreamWithStoredValue<RouteData, SetRouteWaypointsEvent | SetRouteInfoEvent | SetSetModeOfTransportEvent | SwitchRouteEvent>();
